import { createApi } from '@reduxjs/toolkit/query/react';
import {
  AllAttendanceRequest,
  GetEmployeesAttendanceResponse,
  GetRegularizeResponse,
  PutRegularizeRequestStatus,
} from './types';
import { baseQueryWithReauth } from './baseFectch';

export const attendanceApi = createApi({
  reducerPath: 'attendanceApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'queryAllusersAttendance',
    'mutateRole',
    'userAttendanceById',
    'getCurrentUser',
    'allUsersById',
    'userEmployeeAactivityById',
    'userEmployeeStatus',
    'GetRegularizeRequest',
    'monthlyAttendance',
    'PutRegularizeRequestStatus',
  ],
  endpoints: (builder) => ({
    getEmployeesAttendance: builder.query<
      GetEmployeesAttendanceResponse,
      AllAttendanceRequest
    >({
      query: (args) => ({
        url: '/getEmployeesAttendance',
        credentials: 'include',
        params: args,
      }),
      providesTags: ['queryAllusersAttendance'],
    }),

    getEmployeeAactivity: builder.query<
      any,
      {
        employeeId?: string;
        startDate: string;
        endDate: string;
        limit: number;
        page: number;
      }
    >({
      query: ({ employeeId, startDate, endDate, limit = 10, page = 1 }) => ({
        url: `/getemployeeactivity/${employeeId}`,
        method: 'GET',
        params: {
          startDate,
          endDate,
          limit,
          page,
        },
      }),
      providesTags: ['userEmployeeAactivityById'],
    }),

    getRegularizeRequests: builder.query<
      GetRegularizeResponse,
      { page?: number; limit?: number; companyId: string }
    >({
      query: ({ page = 1, limit = 10, companyId }) => ({
        url: `/regularise`,
        method: 'GET',
        params: {
          page,
          limit,
          companyId,
        },
      }),
    }),

    putRegularizeRequestsStatus: builder.mutation<
      any,
      PutRegularizeRequestStatus
    >({
      query: (data) => ({
        url: '/regularise',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['PutRegularizeRequestStatus'],
    }),
    getMonthlyAttendances: builder.query<
      any,
      { startDate: string; endDate: string; companyId: string | undefined }
    >({
      query: ({ startDate, endDate, companyId }) => ({
        url: `/getCurrentMonth`,
        method: 'GET',
        params: { startDate, endDate, companyId },
      }),
      providesTags: ['monthlyAttendance'],
    }),

    getSalaryReport: builder.query<
      any,
      { startDate: string; endDate: string; companyId: string | undefined }
    >({
      query: ({ startDate, endDate, companyId }) => ({
        url: `/report/salary`,
        method: 'GET',
        params: { startDate, endDate, companyId },
      }),

      providesTags: ['monthlyAttendance'],
    }),
    getEmployeeReport: builder.query<
      any,
      { startDate: string; endDate: string; companyId: string | undefined }
    >({
      query: ({ startDate, endDate, companyId }) => ({
        url: `/report/employee`,
        method: 'GET',
        params: { startDate, endDate, companyId },
      }),

      providesTags: ['monthlyAttendance'],
    }),
    getEmployeeMonthly: builder.query<
      any,
      { employeeId: string; startDate: string; endDate: string }
    >({
      query: ({ employeeId, startDate, endDate }) => ({
        url: `/getEmployeeMonthly/${employeeId}`,
        method: 'GET',
        params: { startDate, endDate },
      }),
      providesTags: (result, error, { employeeId }) =>
        result ? [{ type: 'monthlyAttendance', id: employeeId }] : [],
    }),
    getChatBot: builder.mutation<any, any>({
      query: (userData) => ({
        url: `/ai/chatbot`,
        method: 'POST',
        body: userData,
      }),
    }),
  }),
});
export const {
  useLazyGetEmployeesAttendanceQuery,
  useLazyGetEmployeeAactivityQuery,
  useLazyGetMonthlyAttendancesQuery,
  useLazyGetRegularizeRequestsQuery,
  useLazyGetEmployeeMonthlyQuery,
  usePutRegularizeRequestsStatusMutation,
  useGetChatBotMutation,
  useLazyGetEmployeeReportQuery,
  useLazyGetSalaryReportQuery,
} = attendanceApi;
